import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {BsModalEventsEmitter} from 'src/app/modules/shared/events/bsModal.events';
import {LocalisationService} from 'src/app/modules/shared/services/localisation.service';
import {UsersService} from '../../../../shared/services/users.service';
import {MealsComponent} from '../../meals/meals.component';
import {NotificationsService} from '../../../../shared/services/notification.service';
import {DiaryRecipeViewModel} from '../../../../shared/viewModels/diaryRecipe.viewModel';
import {DiaryService} from '../../../../shared/services/diary.service';
import {PricingService} from '../../../../pricing/services/pricing.service';
import {UpgradeComponent} from '../../../../shared/components/modals/upgrade/upgrade.component';
import {DailyChangesActivitiesViewModel} from '../../../../shared/viewModels/trainingActivity.viewModel';
import {forkJoin} from 'rxjs';
import {AppLoadingEventsEmitter} from '../../../../shared/events/loading.events';
import {UserProfileViewModel} from '../../../../shared/viewModels/userProfile.viewModel';

@Component({
    selector: 'app-daily-changes-activities',
    templateUrl: './daily-changes-activities.component.html',
    styleUrls: ['./daily-changes-activities.component.scss']
})
export class DailyChangesActivitiesComponent implements OnInit, AfterViewInit {
    private readonly mobileWidth: number = 576;

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;

    diaryRecipe: DiaryRecipeViewModel;
    mealsComponent: MealsComponent;

    isAllowed = false;
    upgradeModal: BsModalRef;

    dailyChangesActivities: DailyChangesActivitiesViewModel[];
    enabledByActivities: { [key: number]: boolean; } = {};

    minsByActivities: { [key: number]: number; } = {};
    userProfile: UserProfileViewModel;

    enabledByStressLevel: { [key: number]: boolean; } = {};
    stressLevels = [];

    enabledByBrainLevels: { [key: number]: boolean; } = {};
    minsByBrainLevels: { [key: number]: number; } = {};

    brainLevels = [];

    constructor(
        public readonly bsModalRef: BsModalRef,
        private readonly bsModalService: BsModalService,
        private readonly bsModalEventsEmitter: BsModalEventsEmitter,
        private readonly usersService: UsersService,
        private readonly localisationService: LocalisationService,
        private readonly diaryService: DiaryService,
        private readonly pricingService: PricingService,
        private readonly notificationService: NotificationsService,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
        public readonly changeDetectorRef: ChangeDetectorRef,
    ) {
        this.stressLevels = [
            {'id': 'temporary', 'title': this.localisationService.localise('dashboard_increased_level_stress_answer_1')},
            {'id': 'constant', 'title': this.localisationService.localise('dashboard_increased_level_stress_answer_2')}
        ];

        this.brainLevels = [
            {'id': 'brain_temporary', 'title': this.localisationService.localise('dashboard_increased_level_brain_answer_1')},
        ];
    }

    ngOnInit() {
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.enabledByStressLevel['constant'] = false;
        this.enabledByStressLevel['temporary'] = false;
        this.enabledByBrainLevels['brain_temporary'] = false;

        const interval = setInterval(() => {
            if (this.mealsComponent) {
                clearInterval(interval);

                forkJoin(
                    this.usersService.getDailyChangesActivities(),
                    this.diaryService.getAdditionalDiaryTrainings(this.mealsComponent.date),
                    this.pricingService.isPermissionAllowed(this.pricingService.permissions['EXTERNAL_LOAD']),
                )
                    .subscribe(([dailyChangesActivities, diaryAdditionalTrainings, isAllowed]) => {
                        this.isAllowed = isAllowed;
                        this.dailyChangesActivities = dailyChangesActivities;


                        if (Object.keys(diaryAdditionalTrainings).length > 0) {
                            this.enabledByStressLevel['constant'] = diaryAdditionalTrainings.stress_level_constant;
                            this.enabledByStressLevel['temporary'] = diaryAdditionalTrainings.stress_level_temporary;
                            this.enabledByBrainLevels['brain_temporary'] = diaryAdditionalTrainings.brain_level_temporary;
                            this.minsByBrainLevels['brain_temporary'] = diaryAdditionalTrainings.brain_level_temporary_minutes;

                            // tslint:disable-next-line:forin
                            for (const key in diaryAdditionalTrainings.additional_daily_changes) {
                                this.enabledByActivities[diaryAdditionalTrainings.additional_daily_changes[key].daily_changes_activity.id] = true;
                                this.minsByActivities[diaryAdditionalTrainings.additional_daily_changes[key].daily_changes_activity.id] = diaryAdditionalTrainings.additional_daily_changes[key].minutes;
                            }
                        }

                        if (this.usersService.userProfile) {
                            this.userProfile = this.usersService.userProfile;
                        }

                        this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                    });
            }
        }, 100);
    }

    ngAfterViewInit() {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        }
    }

    openUpgradeModal() {
        this.upgradeModal = this.bsModalService.show(UpgradeComponent, {
            backdrop: true
        });

        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.upgradeModal);
    }

    private toFullscreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }

    save() {
        if (this.isAllowed === false) {
            this.openUpgradeModal();
        } else {
            this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

            const updateDiaryTrainings = () => {
                this.diaryService.updateDiaryAdditionalTrainings(this.mealsComponent.date, {
                    stress_level_temporary: this.enabledByStressLevel['temporary'],
                    stress_level_constant: this.enabledByStressLevel['constant'],
                    brain_level_temporary: this.enabledByBrainLevels['brain_temporary'],
                    brain_level_temporary_minutes: this.minsByBrainLevels['brain_temporary'],
                    additional_trainings: this.convertToTrainingsDTO()
                })
                    .subscribe(() => {
                        this.appLoadingEventsEmitter.broadcastAppIsLoading(false);

                        this.notificationService.success(this.localisationService.localise('diary_training_update_success'));

                        this.bsModalRef.hide();
                        this.mealsComponent.init().subscribe();
                    }, () => {
                        this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                    });
            };

            if (!this.mealsComponent.diary) {
                this.mealsComponent.createDiary().subscribe(() => {
                    updateDiaryTrainings();
                });
            } else {
                updateDiaryTrainings();
            }
        }
    }

    convertToTrainingsDTO() {
        const dtoData = [];

        Object.keys(this.enabledByActivities).map(activityId => {
            if (this.enabledByActivities[activityId] === true && this.minsByActivities[activityId] >= 0) {
                dtoData.push({
                    'daily_changes_activity_id': activityId,
                    'minutes': this.minsByActivities[activityId],
                });
            }

        });

        return dtoData;
    }

    markActivity(id: number) {
        if (!this.enabledByActivities[id]) {
            const mins = window.prompt(this.localisationService.localise('dashboard_extra_load_minutes'));

            // tslint:disable-next-line:radix
            if (mins !== null && parseInt(mins) > 0) {
                // tslint:disable-next-line:radix
                this.minsByActivities[id] = parseInt(mins);

                if (this.minsByActivities[id] > 1440) {
                    this.minsByActivities[id] = 1440;
                }

                this.enabledByActivities[id] = true;
            }
        } else {
            delete this.minsByActivities[id];
            this.enabledByActivities[id] = false;
        }

        this.changeDetectorRef.markForCheck();
    }

    markStressLevel(id: string) {
        this.enabledByStressLevel[id] = !this.enabledByStressLevel[id];

        for (const key of Object.keys(this.enabledByStressLevel)) {
            if (key !== id) {
                delete this.enabledByStressLevel[key];
            }
        }
    }

    markBrainLevel(id: string) {
        if (!this.enabledByBrainLevels[id]) {
            const mins = window.prompt(this.localisationService.localise('dashboard_extra_load_minutes'));

            // tslint:disable-next-line:radix
            if (mins !== null && parseInt(mins) > 0) {
                // tslint:disable-next-line:radix
                this.minsByBrainLevels[id] = parseInt(mins);

                if (this.minsByBrainLevels[id] > 1440) {
                    this.minsByBrainLevels[id] = 1440;
                }

                this.enabledByBrainLevels[id] = true;
            }
        } else {
            delete this.minsByBrainLevels[id];
            this.enabledByBrainLevels[id] = false;
        }

        this.changeDetectorRef.markForCheck();
    }

    isIOS() {
        return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
    }
}
